export default __webpack_public_path__ + "static/media/money-back.56f14cb8.png";